import { Alert, message, Modal, Button } from 'antd';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import dayjs from 'dayjs';
import EnergyFilters from './filters';
import EnergyTransactionsGrid from './grid';
import apiCalls from 'src/api/apiCalls';

const EnergyTransactions = ({ visible, onClose }) => {
  const [filterValues, setFilterValues] = useState({ "address": null, "startDate": null, "endDate": null });
  const [error, setError] = useState(null);
  const shouldLog = useRef(true);
  const [isExcelExport, setIsExcelExport] = useState(false);
  const [addressLu, setAddressLu] = useState([]);
  const refreshRef = useRef();

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
    }
  }, [])
  useEffect(() => {
    getAddressLuData();
  }, [])
  const getAddressLuData = async () => {
    try {
      const response = await apiCalls.getTransactionsAddressLu();
      if (response.ok) {
        setAddressLu(response.data);
      } else {
        setError(isErrorMessage(response));
      }
    } catch (err) {
      setError(err.message || 'An unexpected error occurred while fetching address lookup data.');
    }
  };

  const handleSearch = useCallback((values) => {
    let formattedDates = null;
    if (values?.dateRange) {
      formattedDates = values?.dateRange ? values?.dateRange?.map(date => dayjs(date).format('YYYY-MM-DD')) : null
    }
    setFilterValues({
      address: values?.address || null,
      startDate: formattedDates ? formattedDates[0] : null,
      toDate: formattedDates ? formattedDates[1] : null,
    });
  }, [])

  const handleExcelExport = useCallback(() => {
    setIsExcelExport(true);
    setTimeout(() => {
      setIsExcelExport(false)
    });
    message.destroy();
    message.success({
      content: 'Download Excel Successfully',
      className: 'custom-msg',
      duration: 3
    });
  }, [])

  const handleError = useCallback((error) => {
    setError(error)
  }, [])

  const closeError = useCallback(() => {
    setError(null)
  }, [])

  const modalContent = (
    <>
      {error &&
        <div className='mb-4'>
          <Alert
            className='mb-6'
            type="error"
            description={error}
            onClose={closeError}
            showIcon
            closable
          />
        </div>
      }
      <EnergyFilters
        handleExcelExport={handleExcelExport}
        filterObj={handleSearch}
        filterValues={filterValues}
        onloadGrid={refreshRef?.current?.loadGrid}
        handleError={handleError}
        addressLu={addressLu}
      />
      <EnergyTransactionsGrid
        filterValues={filterValues}
        ref={refreshRef}
        isExcelExport={isExcelExport}
        handleError={handleError}
      />
    </>
  );

  return (
    <Modal
      title={"Energy Transactions"}
      visible={visible}
      onCancel={onClose}
      width="70%"
      footer={[
        <Button key="close" className="primary-btn" onClick={onClose}>
          Close
        </Button>
      ]}
      className="energy-transactions-modal"
    >
      {modalContent}
    </Modal>
  );
}

export default React.memo(EnergyTransactions);
